import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const TextInput = ({ isValid, containerClass, errorMessage, ...props }) => {
    const inputContainerClass = classnames(containerClass, {
        'form-item': true,
        'form-item--error': !isValid
    });
    return (
        <div className={inputContainerClass}>
            <input type="text"                
                {...props}
                />
            {!isValid &&
                <div className="error-message">{errorMessage}</div>
            }
        </div>
    )
}

TextInput.propTypes = {
    isValid: PropTypes.bool,
    errorMessage: PropTypes.string,
}

TextInput.defaultProps = {
    value: null,
    isValid: true,
    errorMessage: "Invalid input",
};


export default TextInput